webpackJsonpPois([2],{

/***/ 1985:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1986);

__webpack_require__(359);

var _client = __webpack_require__(360);

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _client2.default)(window.__initialState);

/***/ }),

/***/ 1986:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1985]);


// WEBPACK FOOTER //
// list.a90ee631ceed58404627.js